
import { get, post } from '../utils/http'

export const fetchNewsEntries = (id) => {
  return get('NEWSENTRY_FETCH', `/admin/newsentries`);
}

export const editNewsEntry = (newsentry) => ({ type: 'NEWSENTRY_EDIT', payload: newsentry })

export const cancelEdit = () => ({ type: 'NEWSENTRY_CANCEL_EDIT' })

export const showEdit = () => ({ type: 'NEWSENTRY_SHOW_EDIT' })

export const deleteNewsEntry = (id) => {
  let form = new FormData();
  form.append('id', id);  

  return post('NEWSENTRY_DELETE', '/admin/newsentries/delete', form);
};

export const filter = (query) => ({type: 'NEWSENTRY_FILTER', payload:query })

export const filterDb = (query) => ({type: 'NEWSENTRY_FILTER_DB', payload:query })

export const save = (newsentry, publishedDateString) => {

  let attributes = ['id', 'title', 'content', 'dbType', 'sortOrder'];
  let form = new FormData();

  attributes.forEach(a => form.append(a, newsentry[a] || ''));

  form.append('publishedDateString', publishedDateString);
  form.append('lawEntry', !!newsentry.lawEntry);
  form.append('publishedOnStartPage', !!newsentry.publishedOnStartPage);
    
  return post('NEWSENTRY_SAVE', '/admin/newsentries/update', form);
}


export const editAttr = (attr, value) => ({ type: 'NEWSENTRY_ATTR_EDIT', payload: { attr, value } });


// WEBPACK FOOTER //
// ./src/newsentry/newsentryActions.js